import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaComments, FaTimes } from 'react-icons/fa';
import { getChatReturn, clearChatReturn } from '../../utils/chatReturn';
import './ChatReturnBubble.css';

/**
 * ChatReturnBubble — aktif bir canlı görüşmeden ayrılan kullanıcıya, sitenin
 * her sayfasında gösterilen "sohbete dön" baloncuğu. Bağlantı
 * utils/chatReturn.js üzerinden localStorage'da tutulur.
 */
const ChatReturnBubble = () => {
  const { t } = useTranslation();
  const [entry, setEntry] = useState(() => getChatReturn());

  // Sekme tekrar görünür olduğunda (başka sekmede temizlenmiş olabilir) tazele.
  useEffect(() => {
    const refresh = () => setEntry(getChatReturn());
    window.addEventListener('focus', refresh);
    return () => window.removeEventListener('focus', refresh);
  }, []);

  if (!entry) return null;

  const dismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    clearChatReturn();
    setEntry(null);
  };

  return (
    <div className="crb-root">
      <Link className="crb-bubble" to={entry.url}>
        <span className="crb-icon" aria-hidden="true">
          <FaComments />
        </span>
        <span className="crb-label">{t('consultingRoom.backToChat', 'Go back to Chat')}</span>
      </Link>
      <button
        type="button"
        className="crb-close"
        onClick={dismiss}
        aria-label={t('consultingRoom.closeBubble', 'Close')}
      >
        <FaTimes />
      </button>
    </div>
  );
};

export default ChatReturnBubble;
